// extracted by mini-css-extract-plugin
module.exports = {"sticky_container":"styles_sticky_container__uazWg","page_header":"styles_page_header__Y-nbs"};